export default "__VITE_ASSET__BxphqYIR__"